import { render, staticRenderFns } from "./ApplicationFooter.vue?vue&type=template&id=a0d7b090&scoped=true&"
import script from "./ApplicationFooter.vue?vue&type=script&lang=ts&"
export * from "./ApplicationFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0d7b090",
  null
  
)

export default component.exports